import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

import { toast } from "react-toastify";

import { DistrictActionTypes, DistrictActions } from "../../../actionTypes/master/districtActionTypes";
import { createDistrictApi, deleteDistrictById, editDistrictDataByIdApi, getDistrictDataByIdApi, getDistrictListApi } from "../../requests/master/districtRequest";
import { getDistrictList, setDistrictDataById, setDistrictList, setDistrictListPageCount } from "../../../actions/master/districtActions";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createDistrictHandler(action: DistrictActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createDistrictApi, action.payload);

    if (data.status) {
      
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getDistrictListHandler(action: DistrictActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getDistrictListApi, action.payload);

    if (data.status) {
      yield put(setDistrictList(data?.data?.rows));
      yield put(setDistrictListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getDistrictDataByIdHandler(action: DistrictActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getDistrictDataByIdApi, action.payload);
    if (data.status) {
      yield put(setDistrictDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editDistrictDataByIdHandler(action: DistrictActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editDistrictDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getDistrictList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* deleteDistrictHandler(action: DistrictActionTypes) {
  try {
    yield startLoader("transparent");

    const { data } = yield call(deleteDistrictById, action.payload);
    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(getDistrictList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

// district sagas

export default function* districtSaga() {
  yield takeLatest(DistrictActions.CREATE_DISTRICT, createDistrictHandler);
  yield takeLatest(DistrictActions.GET_DISTRICT_LIST, getDistrictListHandler);
  yield takeLatest(DistrictActions.GET_DISTRICT_DATA_BY_ID, getDistrictDataByIdHandler);
  yield takeLatest(DistrictActions.EDIT_DISTRICT_DATA_BY_ID, editDistrictDataByIdHandler);
  yield takeLatest(DistrictActions.DELETE_DISTRICT, deleteDistrictHandler);
}
